import DemographicsView from '@app/components/DemographicsView'
import PageSection from '@app/components/PageSection'
import RaceEthnicityBreakdownView from '@app/components/RaceEthnicityBreakdownView'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Button } from 'reactstrap'
import { CityViewPageProps } from './CityViewPage'

export default class CityDemographics extends React.PureComponent<
  CityViewPageProps
> {
  public render() {
    const docTitle = `${this.props.city.place.cityState} :: Demographics`

    if (!this.props.city.demographics) {
      return (
        <DocumentTitle title={docTitle}>
          <div className='text-center'>
            <div>
              Demographics information for {this.props.city.place.cityState} is
              not available
            </div>
            {this.props.permissions.canEdit === true && (
              <div className='my-2'>
                <Button
                  color='primary'
                  disabled={this.props.isUpdatingDemographics}
                  onClick={() =>
                    this.props.updateDemographics(this.props.city.id)
                  }
                >
                  Update Demographics Now
                </Button>
              </div>
            )}
          </div>
        </DocumentTitle>
      )
    }

    return (
      <DocumentTitle title={docTitle}>
        <div>
          <PageSection title='Population Summary'>
            <DemographicsView demographics={this.props.city.demographics} />
          </PageSection>
          {this.props.city.demographics.raceEthnicityBreakdown && (
            <PageSection title='Race / Ethnicity Breakdown'>
              <RaceEthnicityBreakdownView
                raceEthnicityBreakdown={
                  this.props.city.demographics.raceEthnicityBreakdown
                }
              />
            </PageSection>
          )}
        </div>
      </DocumentTitle>
    )
  }
}
